<div class="space-y-2">
  <div class="border border-gray-400 overflow-hidden" style="height: 210px; width: 100%;">
    <video autoplay loop muted playsinline width="100%" height="auto" class="object-contain">
      <source src="/videos/frame.mp4" type="video/mp4" />
    </video>
  </div>
  <div>
    Click "Tag Frames", then click-and-drag around each frame to create clips. Make sure to capture the entire
    frame, including all dimensions and labels.
  </div>
</div>
